'use strict';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteSearch', () => ({

		query     : '',
		results   : '',
		hasResults: false,

		search() {
			if ( 3 > this.query.length ) {
				this.hasResults = false;
				this.results    = '';
				return;
			}

			fetch(
				window.avincAjax.url + '?action=avinc_site_search&search=' + encodeURIComponent( this.query )
			)
				.then( ( response ) => response.text() )
				.then( ( html ) => {
					this.results    = html;
					this.hasResults = 0 < html.length;
				});
		},
	}) );
});
